import React from "react";
import { Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import LinkBox from "../../../components/Content/LinkBox/index";
import { Gapper } from "../../../components/ui/Gapper";
import {
  PAGE_TITLE,
  INTRO_HTML,
  LINK_BOX_TITLE,
  LINK_BOX_URL,
  BENEFITS_SECTION_TITLE,
  BENEFITS,
  FOOTER_TEXT_ENCOURAGE,
  FOOTER_TEXT_BREAKDOWN,
} from "./Conferences.constants";
import {
  RootBox,
  BenefitsGrid,
  StyledImage,
  BodyTypography,
  BodyTypographyTight,
  BodyTypographySpaced,
  BenefitRow,
  BenefitIcon,
  BenefitText,
} from "./Conferences.styles";

import conferenceImage from "../../../assets/images/conference.webp";

const Conferences = () => {
  return (
    <RootBox>
      <PageTitle title={PAGE_TITLE} noIcon />

      <StyledImage src={conferenceImage} alt="conference" />

      <BodyTypography dangerouslySetInnerHTML={{ __html: INTRO_HTML }} />

      <LinkBox title={LINK_BOX_TITLE} link={LINK_BOX_URL} />

      <BodyTypographyTight>{BENEFITS_SECTION_TITLE}</BodyTypographyTight>

      <BenefitsGrid container spacing={2}>
        {BENEFITS.map((item) => (
          <Grid2 item key={item.id} size={{ xs: 12, sm: 4 }}>
            <BenefitRow direction="row" spacing={2}>
              <BenefitIcon />
              <BenefitText dangerouslySetInnerHTML={{ __html: item.html }} />
            </BenefitRow>
          </Grid2>
        ))}
      </BenefitsGrid>
      <Gapper gap={20}>
        <BodyTypographySpaced>{FOOTER_TEXT_ENCOURAGE}</BodyTypographySpaced>
        <BodyTypographySpaced>{FOOTER_TEXT_BREAKDOWN}</BodyTypographySpaced>
      </Gapper>
    </RootBox>
  );
};

export default Conferences;
